<template>
  <div class="container mx-auto bg-white md:bg-transparent flex flex-row justify-center lg:justify-between">
    <div class="hidden lg:inline-block">&nbsp;</div>
    <img src="@/assets/images/header_mobile.svg"/>
    <div class="hidden lg:inline-block self-end progress">
      <StepProgress :step="step"/>
    </div>
  </div>
</template>

<script>
import StepProgress from '@/components/StepProgress.vue'

export default {
  name: 'PageHeader',
  props: {
    step: {}
  },
  components: { StepProgress }
}
</script>

<style scoped>

.progress {
  width: 120px;
  margin-bottom: 15px;
  margin-right: 15px;
}
</style>
